import type { RequestConfig } from './types';

export class FetchError<T = unknown> extends Error {
  constructor(
    message: string,
    public status: number,
    public response?: T,
    public config?: RequestConfig,
  ) {
    super(message);
    this.name = 'FetchError';
  }
}
